import { Control, Controller } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Radio } from 'antd';
import { PROMOTION_TYPE_MAP } from 'constant/pms-product';

const ProductPromotionType = ({
  control,
}: {
  control: Control<CreateProductFormSchemaType>;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel required>{i18n.t(LOCALS.on_sale)}:</FormLabel>
      <Controller
        name="promotionType"
        control={control}
        render={({ field }) => (
          <Radio.Group {...field} optionType="button" buttonStyle="solid">
            <Radio value={PROMOTION_TYPE_MAP.NORMAL}>{i18n.t(LOCALS.no)}</Radio>
            <Radio value={PROMOTION_TYPE_MAP.SPECIAL}>
              {i18n.t(LOCALS.yes)}
            </Radio>
          </Radio.Group>
        )}
      />
    </div>
  );
};

export default ProductPromotionType;
